import React from 'react';

import { DollarInputField } from '../../../Fields';
import { FunnelViewProps } from '../../types';
import { NeedsAndAnalysisCommon } from '../NeedsAndAnalysisCheckboxVariationCustomerView';

interface EstimatedImpactAmountProps extends FunnelViewProps, NeedsAndAnalysisCommon {}

export const EstimatedImpactAmount: React.FC<EstimatedImpactAmountProps> = (props) => {
  const { name, isDisabled, ...rest } = props;

  return (
    <DollarInputField
      {...rest}
      name={name}
      isDisabled={isDisabled}
      isZeroValid={false}
      validationFailMessage={'Please enter an amount greater than $0.'}
    />
  );
};
